var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicessImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0F74BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24L23.6422 28.8211C23.7734 28.8867 23.839 28.9195 23.9078 28.9324C23.9687 28.9438 24.0313 28.9438 24.0922 28.9324C24.161 28.9195 24.2266 28.8867 24.3578 28.8211L34 24M14 29L23.6422 33.8211C23.7734 33.8867 23.839 33.9195 23.9078 33.9324C23.9687 33.9438 24.0313 33.9438 24.0922 33.9324C24.161 33.9195 24.2266 33.8867 24.3578 33.8211L34 29M14 19L23.6422 14.1789C23.7734 14.1133 23.839 14.0805 23.9078 14.0676C23.9687 14.0562 24.0313 14.0562 24.0922 14.0676C24.161 14.0805 24.2266 14.1133 24.3578 14.1789L34 19L24.3578 23.8211C24.2266 23.8867 24.161 23.9195 24.0922 23.9324C24.0313 23.9438 23.9687 23.9438 23.9078 23.9324C23.839 23.9195 23.7734 23.8867 23.6422 23.8211L14 19Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicessImg4);
export default __webpack_public_path__ + "static/media/servicessImg4.f17657ea79426057bc78992bdc882c25.svg";
export { ForwardRef as ReactComponent };